import React, { Fragment, useState } from "react";
import PropTypes from 'prop-types';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import ProductModal from "./ProductModal";
import "./ProductModalList.scss"

export default function ProductModalList({data, carriers}) {

  const [productModalShow, setProductModalShow] = useState(false);
  const [modalContentIndex, setModalContentIndex] = useState(null);

  const handleProductModalShow = (index) => {
    handleModalContent(index);
    setProductModalShow(true);
  };

  const handleModalContent = (index) => {
    setModalContentIndex(index);
  };

  return (
      <div className="modal-list-container">
        <Fragment>
          {data.map((p,index) => {
            if (p.rider || p.shouldShow || p.productHighlight) {
              return   <button className="button-pill background" key={index} onClick={() => handleProductModalShow(index)}>
                          <span className="title textColor">{p.rider ? p.rider : p.productHighlight}</span>
                          <InfoIcon className="textColor" />
                        </button>
              }
            }
          )}
          {data[modalContentIndex] && 
            <ProductModal
              productModalShow={productModalShow}
              setProductModalShow={setProductModalShow}
              productData={data[modalContentIndex]}
            />
          }
        </Fragment>
      </div>
  )
}

ProductModalList.propTypes = {
  data: PropTypes.array,
};
